import { graphql } from 'gatsby';
import { Container, Image, Wrapper } from './Interstitial.styles';
import { type BlockHTMLId } from '@/utils/renderBlock';

const Interstitial = ({
  interstitialElements: elements,
  system,
  id,
}: Queries.INTERSTITIALFragment & BlockHTMLId) => {
  const isVisibleOnLargeScreenOnly = ['window_left', 'window_right'].includes(elements.align.value);

  return (
    <Container
      data-codename={system.codename}
      isVisibleOnLargeScreenOnly={isVisibleOnLargeScreenOnly}
      id={id}
    >
      <Wrapper>
        <Image
          alignment={elements.align.value}
          alt={elements.asset.value.description ?? ''}
          src={elements.asset.value.url}
          verticalAlignment={elements.vertical_alignment?.value ?? 'middle'}
        />
      </Wrapper>
    </Container>
  );
};

export const fragment = graphql`
  fragment INTERSTITIAL on kontent_item_interstitial {
    interstitialElements: elements {
      asset {
        value {
          url
          description
        }
      }
      align {
        value
      }
      vertical_alignment {
        value
      }
    }
    system {
      codename
      id
    }
  }
`;

export default Interstitial;
